import React from 'react';
import { queueMetric } from 'modules/metrics';
import { LocaleIntlProvider } from 'modules/intl';
import { SplashLogo } from 'modules/loading/SplashLogo';
import Theme from '../../Theme';
import NoAccess from './access/NoAccess';

const NoLoginAccessFC: React.FC = () => {
  queueMetric('login-no-access');
  return (
    <Theme direction={'ltr'}>
      <LocaleIntlProvider loadingComponent={<SplashLogo />} locale={'en-US'}>
        <NoAccess />
      </LocaleIntlProvider>
    </Theme>
  );
};

export const NoLoginAccess = React.memo<React.FC>(NoLoginAccessFC);
